<template lang="pug">
  SearchConditions(:initSearchCond="initSearchCond" @onChangeSearchConditions="onChangeSearchConditions")
    template(v-slot:conditions="{ conditions }")
      v-layout(wrap)
        v-flex(md3)
          v-text-field(label="荷主" v-model="conditions.clientName")
        v-flex(md3)
          v-text-field(label="荷主枝番" v-model="conditions.clientBranchName")
        v-flex(md3)
          v-text-field(label="1次委託先会社" v-model="conditions.primaryDeliveryCompanyName")
      v-layout(wrap)
        v-flex(md2)
          v-text-field(label="積地CD" v-model="conditions.loadingBaseCd")
        v-flex(md2)
          v-text-field(label="積地名" v-model="conditions.loadingBaseName")
        v-flex(md2)
          v-text-field(label="卸地CD" v-model="conditions.unloadingBaseCd")
        v-flex(md2)
          v-text-field(label="卸地名" v-model="conditions.unloadingBaseName")
        v-flex(md2)
          DatePicker(pickerLabel="適用開始日(開始)" :initDate="conditions.applicableStartDateMin" :inputDate.sync="conditions.applicableStartDateMin" :isClearable="true")
        v-flex(md2)
          DatePicker(pickerLabel="適用開始日(終了)" :initDate="conditions.applicableStartDateMax" :inputDate.sync="conditions.applicableStartDateMax" :isClearable="true")
        v-flex(md2)
          StatusSelect(:code.sync="conditions.status" :clearable="true")
</template>

<script>
import SearchConditions from "@/components/common/search/SearchConditions";
import DatePicker from "@/components/common/DatePicker";
import StatusSelect from "@/components/common/select/StatusSelect";

export default {
  components: {
    SearchConditions,
    DatePicker,
    StatusSelect
  },
  methods: {
    onChangeSearchConditions(item) {
      this.$emit("onChangeSearchConditions", item);
    },
    initSearchCond() {
      return {
        conditions: {
          clientName: "",
          clientBranchName: "",
          primaryDeliveryCompanyName: "",
          applicableStartDateMin: "",
          applicableStartDateMax: "",
          loadingBaseName: "",
          unloadingBaseName: "",
          loadingBaseCd: "",
          unloadingBaseCd: "",
          status: null
        }
      };
    }
  }
};
</script>
